import { useTranslation } from 'react-i18next'
import { biorhythmAdvice, calcBiorhythms } from '@yadviga/shared'
import { useSession } from '../../store/user.store'
import { PageHeader } from '../../components/ui/PageHeader'
import { Button } from '../../components/ui/Button'
import { BiorhythmsGraph } from '../../components/biorhythms/BiorhythmsGraph'

export function ProfileBiorhythmsRoute() {
  const { t, i18n } = useTranslation()
  const user = useSession((s) => s.user)
  const lang = (i18n.language === 'en' ? 'en' : 'ru') as 'ru' | 'en'

  if (!user?.birthDate) {
    return (
      <div className="flex flex-col items-center gap-4 py-10 text-center text-sage-700">
        <PageHeader title={t('bio.title')} backTo="/profile" />
        <p>{t('numbers.no_birth_date')}</p>
        <Button onClick={() => (window.location.href = '/profile')}>{t('numbers.add_birth_date')}</Button>
      </div>
    )
  }

  const values = calcBiorhythms(user.birthDate)
  const advice = biorhythmAdvice(values, lang)

  return (
    <div className="flex flex-col gap-5 pb-6">
      <PageHeader
        title={t('bio.title')}
        subtitle={t('bio.intro')}
        backTo="/profile"
      />

      <div className="flex flex-col gap-3 rounded-3xl bg-white/70 p-5 ring-1 ring-sage-200/60">
        <BiorhythmsGraph birthDate={user.birthDate} />
        <Legend />
      </div>

      <div className="flex flex-col gap-2 rounded-3xl bg-white/60 p-5 ring-1 ring-sage-200/60">
        <h2 className="font-serif text-lg text-sage-800">{t('bio.today_advice')}</h2>
        <p className="leading-relaxed text-sage-800">{advice.text}</p>
      </div>

      <div className="rounded-3xl bg-sage-50/80 p-5 text-sm text-sage-700 ring-1 ring-sage-200/60">
        <p className="leading-relaxed">{t('bio.disclaimer')}</p>
      </div>
    </div>
  )
}

function Legend() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center justify-around gap-3 text-xs">
      <span className="flex items-center gap-1.5">
        <span className="block h-2 w-4 rounded-full" style={{ background: '#b56e3b' }} />
        <span className="text-sage-700">{t('bio.physical')} · 23</span>
      </span>
      <span className="flex items-center gap-1.5">
        <span className="block h-2 w-4 rounded-full" style={{ background: '#c97d7d' }} />
        <span className="text-sage-700">{t('bio.emotional')} · 28</span>
      </span>
      <span className="flex items-center gap-1.5">
        <span className="block h-2 w-4 rounded-full" style={{ background: '#5a7560' }} />
        <span className="text-sage-700">{t('bio.intellectual')} · 33</span>
      </span>
    </div>
  )
}
